const STYLES = {
  planning: "bg-[#F2EFE9] text-[#5C5850]",
  in_progress: "bg-[#F2B91C]/25 text-[#7A5A00]",
  on_hold: "bg-amber-50 text-amber-700",
  completed: "bg-green-50 text-green-700",
  draft: "bg-[#F2EFE9] text-[#5C5850]",
  sent: "bg-blue-50 text-blue-700",
  approved: "bg-green-50 text-green-700",
  declined: "bg-red-50 text-red-700",
  paid: "bg-green-50 text-green-700",
  overdue: "bg-red-50 text-red-700",
  todo: "bg-[#F2EFE9] text-[#5C5850]",
  done: "bg-green-50 text-green-700",
  new: "bg-[#F2B91C]/25 text-[#7A5A00]",
  contacted: "bg-blue-50 text-blue-700",
  won: "bg-green-50 text-green-700",
  lost: "bg-[#F2EFE9] text-[#5C5850]",
  requested: "bg-[#F2B91C]/25 text-[#7A5A00]",
  confirmed: "bg-green-50 text-green-700",
};

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId || "status-badge"}
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${STYLES[status] || STYLES.draft}`}
  >
    {(status || "").replace("_", " ")}
  </span>
);

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl" data-testid="page-title">{title}</h1>
    </div>
    <div className="flex gap-2">{children}</div>
  </div>
);

export const Empty = ({ text, testId }) => (
  <div data-testid={testId || "empty-state"} className="rounded-xl border border-dashed border-[#E6E2DA] bg-white p-10 text-center text-sm text-[#5C5850]">
    {text}
  </div>
);
